import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreService } from '../core.service'
import { SettingsService } from './settings.service';
import { ProfileService } from '../profile/profile.service';

import { Team } from '../app.models';
import { RangePipe } from '../app.pipes';

@Component({
	selector: 'app-settings',
	imports: [ CommonModule, RangePipe ],
	templateUrl: './settings.component.html',
	styleUrl: './settings.component.scss'
})
export class SettingsComponent {

	navigator = navigator;
	constructor(
		public settings: SettingsService,
		public core: CoreService,
		public profile: ProfileService,
	){}

	cycleStars( team_abbr ){
		let score = this.settings['favourite_teams'][team_abbr] || 0;
		score = (score + 1)%6;

		if( score == 0 )
			delete this.settings.favourite_teams[team_abbr]
		else
			this.settings.favourite_teams[team_abbr] = score

		this.settings.save()
	}

}
